// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*-------------------------------------------------------------
	General
-------------------------------------------------------------*/
@media (max-width: 1439px) {
    html {
        font-size: 14px;
    }
}

body {
    font-family: var(--main-font);
    font-weight: var(--main-font-weight);
    margin-bottom: 0;
    /* Overriding bootstrap's base text color #373a3c */
    color: var(--gw-body-color);
    background-color: var(--gw-body-background);
}

code, kbd, pre, samp {
    font-family: var(--mono-font);
}

select {
    font-weight: 400;
}

a {
    color: var(--gw-link-regular-color);
}

/* General links on hover and actual links that lead to an external site */
a:hover, a:active, a[href^="http"], a[href^="http"]:hover, a[href^="http"]:active {
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-thickness: var(--link-decoration-thickness);
    text-underline-offset: var(--link-underline-offset);
}

a:focus, a:hover {
    color: var(--gw-link-regular-hover-color);
}

.font-weight-bold {
    font-weight: bolder;
}

.small, small {
    font-size: 0.875em;
    font-weight: inherit;
}

.text-muted {
    color: var(--gw-text-muted-color) !important
}

.pos-r {
    position: relative;
}

/*-------------------------------------------------------------
	Headings
-------------------------------------------------------------*/
h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
    font-weight: 400;
    margin-bottom: .5em;
}

h1:only-child, h2:only-child, h3:only-child, h4:only-child, h5:only-child, h6:only-child {
    margin-bottom: 0;
}

h1 .btn {
    margin-top: -0.2em
}

/*-------------------------------------------------------------
	Buttons
-------------------------------------------------------------*/
.btn {
    -moz-transition: all 0.15s ease-out; /* FF4+ */
    -o-transition: all 0.15s ease-out; /* Opera 10.5+ */
    -webkit-transition: all 0.15s ease-out; /* Saf3.2+, Chrome */
    transition: all 0.15s ease-out;
}

.btn:disabled,
.btn.disabled,
.btn-link.secondary:disabled,
.text-btn:disabled {
  opacity: var(--gw-button-disabled-opacity);
}

.btn, .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {
    border-radius: 0;
}

.btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {
    outline: 0;
}

.btn-primary {
    color: var(--gw-button-primary-color);
    background-color: var(--gw-button-primary-background);
    border-color: var(--gw-button-primary-border-color);
}

.btn-primary:focus {
    color: var(--gw-button-primary-color);
    background-color: var(--gw-button-primary-background);
    border-color: var(--gw-button-primary-border-color);
}

.btn-primary:hover {
    color: var(--gw-button-primary-hover-color);
    background-color: var(--gw-button-primary-hover-background);
    border-color: var(--gw-button-primary-hover-border-color);
}

.btn-primary.active, .btn-primary:active,
.btn-primary.active:focus, .btn-primary.active:hover,
.btn-primary:active:focus, .btn-primary:active:hover,
.open > .btn-primary.dropdown-toggle,
.open > .btn-primary.dropdown-toggle:focus, .open > .btn-primary.dropdown-toggle:hover {
    color: var(--gw-button-primary-active-color);
    background-color: var(--gw-button-primary-active-background);
    border-color: var(--gw-button-primary-active-border-color);
}

.btn-primary.disabled, .btn-primary:disabled,
.btn-primary.disabled:focus,
.btn-primary:disabled:hover {
    color: var(--gw-button-primary-disabled-color);
    background-color: var(--gw-button-primary-disabled-background);
    border-color: var(--gw-button-primary-disabled-border-color);
}

.btn-secondary {
    color: var(--gw-button-secondary-color);
    background-color: var(--gw-button-secondary-background);
    border-color: var(--gw-button-secondary-border-color);
}

.btn-secondary:focus {
    color: var(--gw-button-secondary-color);
    background-color: var(--gw-button-secondary-background);
    border-color: var(--gw-button-secondary-border-color);
}

.btn-secondary:hover {
    color: var(--gw-button-secondary-hover-color);
    background-color: var(--gw-button-secondary-hover-background);
    border-color: var(--gw-button-secondary-hover-border-color);
}

.btn-secondary.active, .btn-secondary:active,
.btn-secondary.active:focus, .btn-secondary.active:hover,
.btn-secondary:active:focus, .btn-secondary:active:hover,
.open > .btn-secondary.dropdown-toggle,
.open > .btn-secondary.dropdown-toggle:focus, .open > .btn-secondary.dropdown-toggle:hover {
    color: var(--gw-button-secondary-active-color);
    background-color: var(--gw-button-secondary-active-background);
    border-color: var(--gw-button-secondary-active-border-color);
}

.btn-secondary.disabled, .btn-secondary:disabled,
.btn-secondary.disabled:focus,
.btn-secondary:disabled:hover {
    color: var(--gw-button-secondary-disabled-color);
    background-color: var(--gw-button-secondary-disabled-background);
    border-color: var(--gw-button-secondary-disabled-border-color);
}

.btn-group-lg > .btn, .btn-lg {
    padding: .75em 1.2em;
    font-size: 1.125em;
}

.btn-link, .btn-link a {
    color: var(--gw-button-primary-color);
    padding: .5em .8em;
}

.btn-link, .btn-link:hover, .btn-link:focus {
    text-decoration-line: underline;
    text-decoration-style: dotted;
    text-decoration-thickness: var(--link-decoration-thickness);
    text-underline-offset: var(--link-underline-offset);
    color: var(--gw-button-primary-link-hover-color);
}

.btn-link-only-icons,
.btn-link[href]:has([class^="ri"]),
.btn-link[href]:has([class*=" ri"]),
.btn-link[href]:has([class^="ri"]):hover,
.btn-link[href]:has([class*=" ri"]):hover {
    text-decoration: none !important;
}

.btn-link.secondary {
    color: var(--gw-message-help-color);
}

.btn-link:focus, .btn-link:hover, .btn-link.secondary:hover {
    color: var(--gw-button-primary-link-hover-color);
}

.btn-link.disabled:focus, .btn-link.disabled:hover, .btn-link.disabled.secondary:hover {
    color: rgba(0, 0, 0, .3);
}

.btn-link.btn-sm {
    padding: .25rem .5rem;
}

.btn-link.active, .btn-link:hover.active, .btn-link:focus.active, .btn-link:active.active {
    background-color: var(--gw-button-primary-hover-background);
    color: var(--gw-button-primary-hover-color);
}

.btn-link-text {
    padding-left: 0.2em;
}

/* button groups */
.btn-group .btn {
    margin-right: 3px;
}

/* button icons */
.btn [class^="icon-"],
.btn [class^="ri"],
.btn [class*=" ri"] {
    -moz-transition: transform 0.15s ease-out; /* FF4+ */
    -o-transition: transform 0.15s ease-out; /* Opera 10.5+ */
    -webkit-transition: transform 0.15s ease-out; /* Saf3.2+, Chrome */
    transition: transform 0.15s ease-out;
}

.btn [class^="icon-"],
.btn [class^="ri"],
.btn [class*=" ri"] {
    line-height: 0.75;
    font-size: 1.4em;
    display: inline-block;
    vertical-align: middle;
}

.btn.btn-inline [class^="icon-"],
.btn.btn-inline [class^="ri"],
.btn.btn-inline [class*=" ri"] {
    font-size: inherit;
    line-height: inherit;
    vertical-align: inherit;
}

.btn .icon-lg[class^="icon-"],
.btn .icon-lg[class^="ri"],
.btn .icon-lg[class*=" ri"] {
    font-size: 2em;
    margin-right: 0.3em;
}

.btn:hover [class^="icon-"],
.btn:hover [class^="ri"],
.btn:hover [class*=" ri"] {
    transform: scale(1.2);
}

.btn.disabled:hover [class^="icon-"],
.btn.disabled:hover [class^="ri"],
.btn.disabled:hover [class*=" ri"] {
    transform: scale(1);
}

.btn + .dropdown-toggle-split {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}

.btn.p-0 {
    padding: 0.1em !important;
}

.btn-inline.p-0 {
    padding: 0 !important;
}

.btn-inline.b-0 {
    border: 0 !important;
}

.btn .multiline-text {
    margin-top: -0.3em;
    margin-bottom: -0.3em;
}

/* collapse button */
.btn.collapsed [class^=icon-] {
    transform: rotate(180deg);
}

h3 [class^=icon-] {
    vertical-align: -0.1em;
    transition: transform 0.15s ease-out;
}

/*-------------------------------------------------------------
	Text
-------------------------------------------------------------*/
.multiline-text {
    line-height: 0.75em;
    display: inline-block;
    vertical-align: middle;
    text-align: left;
}

.multiline-text small {
    font-weight: 300;
    font-size: 0.75em;
    margin-top: 0.3em;
    display: inline-block;
    max-width: 120px;
    text-overflow: ellipsis;
    overflow: hidden;
}

.text-primary {
    color: var(--gw-primary-base) !important;
}

.text-secondary {
    color: var(--gw-secondary-base) !important;
}

.text-tertiary {
    color: var(--gw-tertiary-base) !important;
}

.text-danger {
    color: var(--gw-message-error-color) !important;
}

.text-success {
    color: var(--gw-message-success-color) !important;
}

.text-warning {
    color: var(--gw-message-warning-color) !important;
}

.text-info {
    color: var(--gw-message-info-color) !important;
}

/*-------------------------------------------------------------
	Alerts
-------------------------------------------------------------*/
.alert {
    border-radius: 0;
    border: 1px solid transparent;
    position: relative;
    padding: 1em;
}

.alert.compact {
  padding: 0.5rem 0.75rem 0.5rem 3rem;
}

.alert-warning {
    color: var(--gw-message-warning-color);
    background-color: var(--gw-message-warning-background);
    border-color: var(--gw-message-warning-border-color);
}

.alert-info {
    color: var(--gw-message-info-color);
    background-color: var(--gw-message-info-background);
    border-color: var(--gw-message-info-border-color);
}

.alert-help {
    color: var(--gw-message-help-color);
    background-color: var(--gw-message-help-background);
    border-color: var(--gw-message-help-border-color);
}

.alert-success {
    color: var(--gw-message-success-color);
    background-color: var(--gw-message-success-background);
    border-color: var(--gw-message-success-border-color);
}

.alert-danger {
    color: var(--gw-message-error-color);
    background-color: var(--gw-message-error-background);
    border-color: var(--gw-message-error-border-color);
}

.alert-info, .alert-warning, .alert-help, .alert-danger, .alert-success {
    padding-left: 3em;
}

.alert-info:before,
.alert-warning:before,
.alert-help:before,
.alert-danger:before,
.alert-success:before {
    font-family: 'icomoon', sans-serif !important;
    font-size: 1.5em;
    vertical-align: middle;
    line-height: 1;
    position: absolute;
    left: 0.6em;
    top: 0.6em;
}

.alert-info:before {
    color: var(--gw-message-info-color);
}

.alert-warning:before {
    color: var(--gw-message-warning-color);
}

.alert-help:before {
    color: var(--gw-message-help-color);
}

.alert-danger:before {
    color: var(--gw-message-error-color);
}

.alert-success:before {
    color: var(--gw-message-success-color);
}

.alert-info:before {
    content: "\\e924";
}

.alert-warning:before {
    content: "\\e930";
}

.alert-help:before {
    content: "\\e929";
}

.alert-danger:before {
    content: "\\e920";
}

.alert-success:before {
    content: "\\e914";
}

.no-icon {
    padding-left: 1em;
}

.no-icon:before {
    display: none;
}

.alert .alert {
    background-color: transparent;
}

/*-------------------------------------------------------------
	Background colors
-------------------------------------------------------------*/
.bg-primary {
    background-color: var(--gw-primary-base);
}

.bg-secondary {
    background-color: var(--gw-secondary-base);
    color: #fff;
}

.bg-ternary {
    background-color: var(--gw-tertiary-base);
}

.bg-lightgray {
    background-color: #eee;
}

.bg-white {
    background-color: #fff;
}


.pointer-events-none {
    pointer-events: none;
}

.padding-bottom-8 {
    padding-bottom: 8rem;
}

/*-------------------------------------------------------------
	Utilities
-------------------------------------------------------------*/
.rotate-180 {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
`, "",{"version":3,"sources":["webpack://./packages/root-config/src/vendor/common.css"],"names":[],"mappings":"AAAA;;8DAE8D;AAC9D;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;IACpC,gBAAgB;IAChB,mDAAmD;IACnD,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC;;AAEA,0EAA0E;AAC1E;IACI,+BAA+B;IAC/B,4BAA4B;IAC5B,2DAA2D;IAC3D,mDAAmD;AACvD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;8DAE8D;AAC9D;;IAEI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;AACJ;;AAEA;;8DAE8D;AAC9D;IACI,mCAAmC,EAAE,SAAS;IAC9C,iCAAiC,EAAE,gBAAgB;IACnD,sCAAsC,EAAE,oBAAoB;IAC5D,8BAA8B;AAClC;;AAEA;;;;EAIE,0CAA0C;AAC5C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,qDAAqD;IACrD,mDAAmD;AACvD;;AAEA;IACI,qCAAqC;IACrC,qDAAqD;IACrD,mDAAmD;AACvD;;AAEA;IACI,2CAA2C;IAC3C,2DAA2D;IAC3D,yDAAyD;AAC7D;;AAEA;;;;;IAKI,4CAA4C;IAC5C,4DAA4D;IAC5D,0DAA0D;AAC9D;;AAEA;;;IAGI,8CAA8C;IAC9C,8DAA8D;IAC9D,4DAA4D;AAChE;;AAEA;IACI,uCAAuC;IACvC,uDAAuD;IACvD,qDAAqD;AACzD;;AAEA;IACI,uCAAuC;IACvC,uDAAuD;IACvD,qDAAqD;AACzD;;AAEA;IACI,6CAA6C;IAC7C,6DAA6D;IAC7D,2DAA2D;AAC/D;;AAEA;;;;;IAKI,8CAA8C;IAC9C,8DAA8D;IAC9D,4DAA4D;AAChE;;AAEA;;;IAGI,gDAAgD;IAChD,gEAAgE;IAChE,8DAA8D;AAClE;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,6BAA6B;IAC7B,2DAA2D;IAC3D,mDAAmD;IACnD,gDAAgD;AACpD;;AAEA;;;;;IAKI,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,2DAA2D;IAC3D,2CAA2C;AAC/C;;AAEA;IACI,mBAAmB;AACvB;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;;;IAGI,yCAAyC,EAAE,SAAS;IACpD,uCAAuC,EAAE,gBAAgB;IACzD,4CAA4C,EAAE,oBAAoB;IAClE,oCAAoC;AACxC;;AAEA;;;IAGI,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;;;IAGI,kBAAkB;IAClB,oBAAoB;IACpB,uBAAuB;AAC3B;;AAEA;;;IAGI,cAAc;IACd,mBAAmB;AACvB;;AAEA;;;IAGI,qBAAqB;AACzB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;;8DAE8D;AAC9D;IACI,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+CAA+C;AACnD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;;8DAE8D;AAC9D;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;IACI,sCAAsC;IACtC,sDAAsD;IACtD,oDAAoD;AACxD;;AAEA;IACI,mCAAmC;IACnC,mDAAmD;IACnD,iDAAiD;AACrD;;AAEA;IACI,mCAAmC;IACnC,mDAAmD;IACnD,iDAAiD;AACrD;;AAEA;IACI,sCAAsC;IACtC,sDAAsD;IACtD,oDAAoD;AACxD;;AAEA;IACI,oCAAoC;IACpC,oDAAoD;IACpD,kDAAkD;AACtD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;;;;IAKI,6CAA6C;IAC7C,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;8DAE8D;AAC9D;IACI,wCAAwC;AAC5C;;AAEA;IACI,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;;AAGA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;;8DAE8D;AAC9D;EACE,iCAAiC;EACjC,yBAAyB;AAC3B","sourcesContent":["/*-------------------------------------------------------------\n\tGeneral\n-------------------------------------------------------------*/\n@media (max-width: 1439px) {\n    html {\n        font-size: 14px;\n    }\n}\n\nbody {\n    font-family: var(--main-font);\n    font-weight: var(--main-font-weight);\n    margin-bottom: 0;\n    /* Overriding bootstrap's base text color #373a3c */\n    color: var(--gw-body-color);\n    background-color: var(--gw-body-background);\n}\n\ncode, kbd, pre, samp {\n    font-family: var(--mono-font);\n}\n\nselect {\n    font-weight: 400;\n}\n\na {\n    color: var(--gw-link-regular-color);\n}\n\n/* General links on hover and actual links that lead to an external site */\na:hover, a:active, a[href^=\"http\"], a[href^=\"http\"]:hover, a[href^=\"http\"]:active {\n    text-decoration-line: underline;\n    text-decoration-style: solid;\n    text-decoration-thickness: var(--link-decoration-thickness);\n    text-underline-offset: var(--link-underline-offset);\n}\n\na:focus, a:hover {\n    color: var(--gw-link-regular-hover-color);\n}\n\n.font-weight-bold {\n    font-weight: bolder;\n}\n\n.small, small {\n    font-size: 0.875em;\n    font-weight: inherit;\n}\n\n.text-muted {\n    color: var(--gw-text-muted-color) !important\n}\n\n.pos-r {\n    position: relative;\n}\n\n/*-------------------------------------------------------------\n\tHeadings\n-------------------------------------------------------------*/\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n    font-weight: 400;\n    margin-bottom: .5em;\n}\n\nh1:only-child, h2:only-child, h3:only-child, h4:only-child, h5:only-child, h6:only-child {\n    margin-bottom: 0;\n}\n\nh1 .btn {\n    margin-top: -0.2em\n}\n\n/*-------------------------------------------------------------\n\tButtons\n-------------------------------------------------------------*/\n.btn {\n    -moz-transition: all 0.15s ease-out; /* FF4+ */\n    -o-transition: all 0.15s ease-out; /* Opera 10.5+ */\n    -webkit-transition: all 0.15s ease-out; /* Saf3.2+, Chrome */\n    transition: all 0.15s ease-out;\n}\n\n.btn:disabled,\n.btn.disabled,\n.btn-link.secondary:disabled,\n.text-btn:disabled {\n  opacity: var(--gw-button-disabled-opacity);\n}\n\n.btn, .btn-group > .btn:first-child:not(:last-child):not(.dropdown-toggle) {\n    border-radius: 0;\n}\n\n.btn.active.focus, .btn.active:focus, .btn.focus, .btn:active.focus, .btn:active:focus, .btn:focus {\n    outline: 0;\n}\n\n.btn-primary {\n    color: var(--gw-button-primary-color);\n    background-color: var(--gw-button-primary-background);\n    border-color: var(--gw-button-primary-border-color);\n}\n\n.btn-primary:focus {\n    color: var(--gw-button-primary-color);\n    background-color: var(--gw-button-primary-background);\n    border-color: var(--gw-button-primary-border-color);\n}\n\n.btn-primary:hover {\n    color: var(--gw-button-primary-hover-color);\n    background-color: var(--gw-button-primary-hover-background);\n    border-color: var(--gw-button-primary-hover-border-color);\n}\n\n.btn-primary.active, .btn-primary:active,\n.btn-primary.active:focus, .btn-primary.active:hover,\n.btn-primary:active:focus, .btn-primary:active:hover,\n.open > .btn-primary.dropdown-toggle,\n.open > .btn-primary.dropdown-toggle:focus, .open > .btn-primary.dropdown-toggle:hover {\n    color: var(--gw-button-primary-active-color);\n    background-color: var(--gw-button-primary-active-background);\n    border-color: var(--gw-button-primary-active-border-color);\n}\n\n.btn-primary.disabled, .btn-primary:disabled,\n.btn-primary.disabled:focus,\n.btn-primary:disabled:hover {\n    color: var(--gw-button-primary-disabled-color);\n    background-color: var(--gw-button-primary-disabled-background);\n    border-color: var(--gw-button-primary-disabled-border-color);\n}\n\n.btn-secondary {\n    color: var(--gw-button-secondary-color);\n    background-color: var(--gw-button-secondary-background);\n    border-color: var(--gw-button-secondary-border-color);\n}\n\n.btn-secondary:focus {\n    color: var(--gw-button-secondary-color);\n    background-color: var(--gw-button-secondary-background);\n    border-color: var(--gw-button-secondary-border-color);\n}\n\n.btn-secondary:hover {\n    color: var(--gw-button-secondary-hover-color);\n    background-color: var(--gw-button-secondary-hover-background);\n    border-color: var(--gw-button-secondary-hover-border-color);\n}\n\n.btn-secondary.active, .btn-secondary:active,\n.btn-secondary.active:focus, .btn-secondary.active:hover,\n.btn-secondary:active:focus, .btn-secondary:active:hover,\n.open > .btn-secondary.dropdown-toggle,\n.open > .btn-secondary.dropdown-toggle:focus, .open > .btn-secondary.dropdown-toggle:hover {\n    color: var(--gw-button-secondary-active-color);\n    background-color: var(--gw-button-secondary-active-background);\n    border-color: var(--gw-button-secondary-active-border-color);\n}\n\n.btn-secondary.disabled, .btn-secondary:disabled,\n.btn-secondary.disabled:focus,\n.btn-secondary:disabled:hover {\n    color: var(--gw-button-secondary-disabled-color);\n    background-color: var(--gw-button-secondary-disabled-background);\n    border-color: var(--gw-button-secondary-disabled-border-color);\n}\n\n.btn-group-lg > .btn, .btn-lg {\n    padding: .75em 1.2em;\n    font-size: 1.125em;\n}\n\n.btn-link, .btn-link a {\n    color: var(--gw-button-primary-color);\n    padding: .5em .8em;\n}\n\n.btn-link, .btn-link:hover, .btn-link:focus {\n    text-decoration-line: underline;\n    text-decoration-style: dotted;\n    text-decoration-thickness: var(--link-decoration-thickness);\n    text-underline-offset: var(--link-underline-offset);\n    color: var(--gw-button-primary-link-hover-color);\n}\n\n.btn-link-only-icons,\n.btn-link[href]:has([class^=\"ri\"]),\n.btn-link[href]:has([class*=\" ri\"]),\n.btn-link[href]:has([class^=\"ri\"]):hover,\n.btn-link[href]:has([class*=\" ri\"]):hover {\n    text-decoration: none !important;\n}\n\n.btn-link.secondary {\n    color: var(--gw-message-help-color);\n}\n\n.btn-link:focus, .btn-link:hover, .btn-link.secondary:hover {\n    color: var(--gw-button-primary-link-hover-color);\n}\n\n.btn-link.disabled:focus, .btn-link.disabled:hover, .btn-link.disabled.secondary:hover {\n    color: rgba(0, 0, 0, .3);\n}\n\n.btn-link.btn-sm {\n    padding: .25rem .5rem;\n}\n\n.btn-link.active, .btn-link:hover.active, .btn-link:focus.active, .btn-link:active.active {\n    background-color: var(--gw-button-primary-hover-background);\n    color: var(--gw-button-primary-hover-color);\n}\n\n.btn-link-text {\n    padding-left: 0.2em;\n}\n\n/* button groups */\n.btn-group .btn {\n    margin-right: 3px;\n}\n\n/* button icons */\n.btn [class^=\"icon-\"],\n.btn [class^=\"ri\"],\n.btn [class*=\" ri\"] {\n    -moz-transition: transform 0.15s ease-out; /* FF4+ */\n    -o-transition: transform 0.15s ease-out; /* Opera 10.5+ */\n    -webkit-transition: transform 0.15s ease-out; /* Saf3.2+, Chrome */\n    transition: transform 0.15s ease-out;\n}\n\n.btn [class^=\"icon-\"],\n.btn [class^=\"ri\"],\n.btn [class*=\" ri\"] {\n    line-height: 0.75;\n    font-size: 1.4em;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.btn.btn-inline [class^=\"icon-\"],\n.btn.btn-inline [class^=\"ri\"],\n.btn.btn-inline [class*=\" ri\"] {\n    font-size: inherit;\n    line-height: inherit;\n    vertical-align: inherit;\n}\n\n.btn .icon-lg[class^=\"icon-\"],\n.btn .icon-lg[class^=\"ri\"],\n.btn .icon-lg[class*=\" ri\"] {\n    font-size: 2em;\n    margin-right: 0.3em;\n}\n\n.btn:hover [class^=\"icon-\"],\n.btn:hover [class^=\"ri\"],\n.btn:hover [class*=\" ri\"] {\n    transform: scale(1.2);\n}\n\n.btn.disabled:hover [class^=\"icon-\"],\n.btn.disabled:hover [class^=\"ri\"],\n.btn.disabled:hover [class*=\" ri\"] {\n    transform: scale(1);\n}\n\n.btn + .dropdown-toggle-split {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n}\n\n.btn.p-0 {\n    padding: 0.1em !important;\n}\n\n.btn-inline.p-0 {\n    padding: 0 !important;\n}\n\n.btn-inline.b-0 {\n    border: 0 !important;\n}\n\n.btn .multiline-text {\n    margin-top: -0.3em;\n    margin-bottom: -0.3em;\n}\n\n/* collapse button */\n.btn.collapsed [class^=icon-] {\n    transform: rotate(180deg);\n}\n\nh3 [class^=icon-] {\n    vertical-align: -0.1em;\n    transition: transform 0.15s ease-out;\n}\n\n/*-------------------------------------------------------------\n\tText\n-------------------------------------------------------------*/\n.multiline-text {\n    line-height: 0.75em;\n    display: inline-block;\n    vertical-align: middle;\n    text-align: left;\n}\n\n.multiline-text small {\n    font-weight: 300;\n    font-size: 0.75em;\n    margin-top: 0.3em;\n    display: inline-block;\n    max-width: 120px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n}\n\n.text-primary {\n    color: var(--gw-primary-base) !important;\n}\n\n.text-secondary {\n    color: var(--gw-secondary-base) !important;\n}\n\n.text-tertiary {\n    color: var(--gw-tertiary-base) !important;\n}\n\n.text-danger {\n    color: var(--gw-message-error-color) !important;\n}\n\n.text-success {\n    color: var(--gw-message-success-color) !important;\n}\n\n.text-warning {\n    color: var(--gw-message-warning-color) !important;\n}\n\n.text-info {\n    color: var(--gw-message-info-color) !important;\n}\n\n/*-------------------------------------------------------------\n\tAlerts\n-------------------------------------------------------------*/\n.alert {\n    border-radius: 0;\n    border: 1px solid transparent;\n    position: relative;\n    padding: 1em;\n}\n\n.alert.compact {\n  padding: 0.5rem 0.75rem 0.5rem 3rem;\n}\n\n.alert-warning {\n    color: var(--gw-message-warning-color);\n    background-color: var(--gw-message-warning-background);\n    border-color: var(--gw-message-warning-border-color);\n}\n\n.alert-info {\n    color: var(--gw-message-info-color);\n    background-color: var(--gw-message-info-background);\n    border-color: var(--gw-message-info-border-color);\n}\n\n.alert-help {\n    color: var(--gw-message-help-color);\n    background-color: var(--gw-message-help-background);\n    border-color: var(--gw-message-help-border-color);\n}\n\n.alert-success {\n    color: var(--gw-message-success-color);\n    background-color: var(--gw-message-success-background);\n    border-color: var(--gw-message-success-border-color);\n}\n\n.alert-danger {\n    color: var(--gw-message-error-color);\n    background-color: var(--gw-message-error-background);\n    border-color: var(--gw-message-error-border-color);\n}\n\n.alert-info, .alert-warning, .alert-help, .alert-danger, .alert-success {\n    padding-left: 3em;\n}\n\n.alert-info:before,\n.alert-warning:before,\n.alert-help:before,\n.alert-danger:before,\n.alert-success:before {\n    font-family: 'icomoon', sans-serif !important;\n    font-size: 1.5em;\n    vertical-align: middle;\n    line-height: 1;\n    position: absolute;\n    left: 0.6em;\n    top: 0.6em;\n}\n\n.alert-info:before {\n    color: var(--gw-message-info-color);\n}\n\n.alert-warning:before {\n    color: var(--gw-message-warning-color);\n}\n\n.alert-help:before {\n    color: var(--gw-message-help-color);\n}\n\n.alert-danger:before {\n    color: var(--gw-message-error-color);\n}\n\n.alert-success:before {\n    color: var(--gw-message-success-color);\n}\n\n.alert-info:before {\n    content: \"\\e924\";\n}\n\n.alert-warning:before {\n    content: \"\\e930\";\n}\n\n.alert-help:before {\n    content: \"\\e929\";\n}\n\n.alert-danger:before {\n    content: \"\\e920\";\n}\n\n.alert-success:before {\n    content: \"\\e914\";\n}\n\n.no-icon {\n    padding-left: 1em;\n}\n\n.no-icon:before {\n    display: none;\n}\n\n.alert .alert {\n    background-color: transparent;\n}\n\n/*-------------------------------------------------------------\n\tBackground colors\n-------------------------------------------------------------*/\n.bg-primary {\n    background-color: var(--gw-primary-base);\n}\n\n.bg-secondary {\n    background-color: var(--gw-secondary-base);\n    color: #fff;\n}\n\n.bg-ternary {\n    background-color: var(--gw-tertiary-base);\n}\n\n.bg-lightgray {\n    background-color: #eee;\n}\n\n.bg-white {\n    background-color: #fff;\n}\n\n\n.pointer-events-none {\n    pointer-events: none;\n}\n\n.padding-bottom-8 {\n    padding-bottom: 8rem;\n}\n\n/*-------------------------------------------------------------\n\tUtilities\n-------------------------------------------------------------*/\n.rotate-180 {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
